<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">商品栄養成分情報メンテナンス</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input class="pcode" type="text" [(ngModel)]="kymw1107Model.pCode" readonly>
              </div>

              <label class="list-input-title">アイテムコード</label>
              <div class="list-input-content">
                <input class="item-code" type="text" [(ngModel)]="kymw1107Model.itemCode" readonly>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">商品名</label>
              <div class="list-input-content">
                <input class="guide-goods-name" type="text" [(ngModel)]="kymw1107Model.guideGoodsName" readonly>
              </div>

              <label class="list-input-title">規格名</label>
              <div class="list-input-content">
                <input class="guide-standard-name" type="text" [(ngModel)]="kymw1107Model.guideStandardName" readonly>
              </div>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">分析単位</label>
            <div class="list-input-content grid-colspan3">
              <app-not-null-text-area id="txta_AnalysisUnit" #txta_AnalysisUnit [subid]="'txta_AnalysisUnit'"
                [restrict]="'[ -￮]'" [maxChars]="100" [forcedEnabledMode]="''" [tabindex]="0" [style.height.px]="70"
                [(ngModel)]="kymw1107Model.analysisUnit" [width]="'calc(100% - 5rem)'" (keydown)="nextFocus($event)">
              </app-not-null-text-area>
            </div>
          </div>
        </div>
        <div>
          <h1>栄養成分</h1>
          <div class="element-column">
            <wj-flex-grid #dg_NutrientComponentList [itemsSource]="kymw1107Model.nutrientComponentList" [tabindex]="0"
              id="dg_NutrientComponentList" [headersVisibility]="'Column'" [allowSorting]="false" [allowDragging]="'None'"
              [selectionMode]="'Row'" (pasting)="onPasting($event)" [style.width.px]="834">
              <!-- 表示項目 -->
              <wj-flex-grid-column [minWidth]="5" [width]="430" [header]="'栄養成分名'" [binding]="'NutritionalName'"
                [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [class.nutritional-color]="cell.item.PublishDiv==='1'">
                    {{cell.item.NutritionalName}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="270" cssClass="renderer-style" [header]="'栄養成分値'"
                [binding]="'NutritionalQuantity'" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <app-text-input type="text" [maxChars]="20" [style.width.%]="100" [(ngModel)]="cell.value" [tabindex]="0"
                    autocomplete="off" (keydown)="eventGridKeyDownHandler($event,dg_NutrientComponentList,1)"
                    [restrict]="'[ -￮]'" [displayCountField]="false" (blur)="eventQuantity_FOCUSOUTHandler($event, cell)" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'単位'" [binding]="'NutritionalUnit'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <!-- 非表示項目 -->
              <wj-flex-grid-column [minWidth]="5" [header]="'vis1'" [visible]="false" [binding]="'NutritionalCode'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'vis2'" [visible]="false" [binding]="'PublishDiv'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'vis3'" [visible]="false" [binding]="'Hierarchy'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
            </wj-flex-grid>

            <div class="column-list">
              <label class="list-input-title">栄養成分備考</label>
              <div class="list-input-content">
                <app-text-area id="txta_NutritionalNote" [subid]="'txta_NutritionalNote'" [restrict]="'[ -￮]'" [fullOnly]="true"
                  [maxChars]="200" [forcedEnabledMode]="''" [width]="'calc(100% - 5rem)'" [tabindex]="0"
                  [(ngModel)]="kymw1107Model.nutritionalNote" (change)="eventEditHandler()" [style.height.px]="111">
                </app-text-area>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler()"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>